import cloneDeep from 'lodash/cloneDeep'
class AppCache {
  expireTime = {}
  cache = {}
  addCache(type, key, value, expire) {
    const realKey = this.generateKey(type, key)
    this.cache[realKey] = cloneDeep(value)
    this.expireTime[realKey] = new Date().getTime() + expire * 1000
  }
  removeCache(type, key) {
    const realKey = this.generateKey(type, key)
    delete this.cache[realKey]
    delete this.expireTime[realKey]
  }
  getValue(type, key) {
    const realKey = this.generateKey(type, key)
    if (this.expireTime[realKey] && this.expireTime[realKey] > new Date().getTime()) {
      return cloneDeep(this.cache[realKey])
    }
    this.removeCache(type, key)
    return null 
  }
  generateKey(type, key) {
    return `${type}:${key}`
  }
  // 计算年龄的函数
  getAge(birthday) {
    const birthDate = new Date(birthday)
    const currentDate = new Date()
    // 计算年龄
    let age = currentDate.getFullYear() - birthDate.getFullYear()
    const currentMonth = currentDate.getMonth()
    const birthMonth = birthDate.getMonth()
    // 如果当前月份小于生日月份，或者当前月份等于生日月份但当前日期小于生日日期，则年龄减一
    if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDate.getDate() < birthDate.getDate())) {
      age--
    }

    return age
  }
}
export default AppCache
export const GlobalAppCache = new AppCache()
